import { Injectable } from '@angular/core';
import { Rest, RestService } from '@ralba/shared';
import {
  CreateDocumentTagOrganizationUnitDto,
  DocumentTagDto,
  DocumentTagOrganizationUnitDto,
  DocumentTagOrganizationUnitRoleDto,
  MoveDocumentTagOrganizationUnitDto,
  TenancyRequestDto
} from '../dto';

// fill for DocumentTagOrganizationUnitServiceProxy

@Injectable({ providedIn: 'root' })
export class ManageDocumentTagOrganizationUnitHttpApiService {

  constructor(private rest: RestService) { }



  public getList(params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto> = {
      method: 'GET',
      url: '/api/manage/document-tag-organization-unit/get-list',
      params,
    };
    return this.rest.request<TenancyRequestDto, Rest.AbpResponse<DocumentTagOrganizationUnitDto[]>>(request);
  }
  // get
  public get(id: number, params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto<{ id: number }>> = {
      method: 'GET',
      url: '/api/manage/document-tag-organization-unit/' + id,
      params,
    };
    return this.rest.request<TenancyRequestDto<{ id: number }>, Rest.AbpResponse<DocumentTagOrganizationUnitDto>>(request);
  }

  public create(body: TenancyRequestDto<CreateDocumentTagOrganizationUnitDto>) {
    const request: Rest.Request<TenancyRequestDto<CreateDocumentTagOrganizationUnitDto>> = {
      method: 'POST',
      url: '/api/manage/document-tag-organization-unit/create',
      body,
    };
    return this.rest.request<TenancyRequestDto<DocumentTagOrganizationUnitDto>, Rest.AbpResponse<DocumentTagOrganizationUnitDto>>(request);
  }

  public update(id: number, body: TenancyRequestDto<DocumentTagOrganizationUnitDto>) {
    const request: Rest.Request<TenancyRequestDto<DocumentTagOrganizationUnitDto>> = {
      method: 'PUT',
      url: '/api/manage/document-tag-organization-unit/' + id,
      body,
    };
    return this.rest.request<TenancyRequestDto<DocumentTagOrganizationUnitDto>, Rest.AbpResponse<DocumentTagOrganizationUnitDto>>(request);
  }

  public delete(id: number, params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto<{ id: number }>> = {
      method: 'DELETE',
      url: '/api/manage/document-tag-organization-unit/' + id,
      params,
    };
    return this.rest.request<TenancyRequestDto<{ id: number }>, Rest.AbpResponse<void>>(request);
  }

  public move(id: number, body: TenancyRequestDto<MoveDocumentTagOrganizationUnitDto>) {
    const request: Rest.Request<TenancyRequestDto<MoveDocumentTagOrganizationUnitDto>> = {
      method: 'PUT',
      url: '/api/manage/document-tag-organization-unit/' + id + '/move',
      body,
    };
    return this.rest.request<TenancyRequestDto<MoveDocumentTagOrganizationUnitDto>, Rest.AbpResponse<DocumentTagOrganizationUnitDto>>(request);
  }

  public getDocumentTags(params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto> = {
      method: 'GET',
      url: '/api/manage/document-tag-organization-unit/get-document-tags',
      params,
    };
    return this.rest.request<TenancyRequestDto, Rest.AbpResponse<DocumentTagDto[]>>(request);
  }

  public getAssignableRoles(params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto> = {
      method: 'GET',
      url: '/api/manage/document-tag-organization-unit/assignable/role',
      params,
    };
    return this.rest.request<TenancyRequestDto, Rest.AbpResponse<DocumentTagOrganizationUnitRoleDto[]>>(request);
  }

  public getAssignableDocumentTags(params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto> = {
      method: 'GET',
      url: '/api/manage/document-tag-organization-unit/assignable/document-tag',
      params,
    };
    return this.rest.request<TenancyRequestDto, Rest.AbpResponse<DocumentTagDto[]>>(request);
  }


}

